// Modal.js
import React from "react";
import "./Modal.css";

export default function Modal({ open, onClose, title, children }) {
  if (!open) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-container" onClick={(e) => e.stopPropagation()}>
        <h2>{title}</h2>

        <div className="modal-body">{children}</div>

        <button className="modal-close-btn" onClick={onClose}>
          Fenster schließen ✖
        </button>
      </div>
    </div>
  );
}
